import { useContext, useMemo, useState } from "react";
import { UserContext } from "contexts/UserContext/UserContext";
import { TextField, Tooltip, Typography } from "@mui/material";
import { IEventReportDetails } from "entities/EventReports/EventReportsEntityInterfaces";
import { DetailsReportEditionContext } from "contexts/DetailsReportEditionContext/DetailsReportEditionContext";
import { useStyles } from "./NoteTextfield.styles";
import { NOTES_MAX_INPUT_HMI } from "constants/constants";

export const NoteTextfield = ({ row }: { row: IEventReportDetails }) => {
    const { user_id } = useContext(UserContext);
    const { edit, setEdit } = useContext(DetailsReportEditionContext);
    const classes = useStyles();

    const notesLengthToShowTooltip = 6;
    const existingEdition = useMemo(() => edit.findIndex((event) => event.id === row.event_report_id), [edit, row]);
    const notesChanges = useMemo(() => edit[existingEdition]?.changes?.notes, [edit, existingEdition]);
    const [notes, setNotes] = useState<string>(notesChanges || "");

    const handleNotesUpdate = async (value: string) => {
        setNotes(value);
        if (existingEdition !== -1) {
            setEdit((prevEdit) => {
                const newEdit = [...prevEdit];
                newEdit[existingEdition] = {
                    ...newEdit[existingEdition],
                    changes: {
                        ...newEdit[existingEdition]?.changes,
                        notes: value,
                        ...(user_id && { edited_by_user_id: user_id }),
                    },
                };
                return newEdit;
            });
        }
    };

    return (
        <Tooltip
            placement="top"
            PopperProps={{
                className: notes.length > notesLengthToShowTooltip ? classes.tooltip : classes.tooltipDisplayNone,
            }}
            title={<Typography className={classes.tooltipTexts}>{notes}</Typography>}
        >
            <TextField
                aria-labelledby="outlined-short-name-label"
                fullWidth
                id="outlined-short-name-input"
                className={classes.inputStyle}
                name="notes"
                type="text"
                variant="filled"
                value={notes}
                onChange={(e) => handleNotesUpdate(e.target.value)}
                helperText={`${notes.length}/${NOTES_MAX_INPUT_HMI}`}
                inputProps={{ maxLength: NOTES_MAX_INPUT_HMI }}
                FormHelperTextProps={{
                    sx: { textAlign: "right", margin: 0 },
                }}
            />
        </Tooltip>
    );
};
